import { query } from "firebase/database";
import api from "./api";

const lang = localStorage.getItem('lang') || 'en';
const user = localStorage.getItem("user")
export default class API {
  //AUTH
  static async Login(body) {
    return api.request(`api/v2/login?_locale=${lang}`, "POST", body);
  }
  static async SupplierLogin(body) {
    return api.request(`api/merchantLogin`, "POST", body);
  }
  static async SupplierLoginWithOTP(body) {
    return api.request(`api/merchantLoginWithOTP`, "POST", body);
  }
  static async SupplierProducts(body) {
    return api.request(`api/upload`, "POST", body);
  }
  static async StateList() {
    return api.request(`state/list?country_id=99&isSelectBox=1`, "GET");
  }
  static async Register(body) {
    return api.request(`api/v2/register?_locale=${lang}`, "POST", body);
  }
  static async VerifyRegister(body) {
    return api.request(`api/register/verify`, "POST", body);
  }
  static async OTPVerify(body) {
    return api.request(`api/verifyUser`, "POST", body);
  }
  static async OTPVerifyMerchant(body) {
    return api.request(`api/verifyMerchantOTP`, "POST", body);
  }
  static async PasswordRequest(body) {
    return api.request(`api/v2/changeUserPasswordRequest`, "POST", body);
  }
  static async VerifyPasswordChange(body) { 
    return api.request(`api/verifyChangePassword`, "POST", body);
  }
  static async PasswordChange(body) {
    return api.request(`api/v2/changeUserPassword`, "POST", body);
  }
  static async ChangeLoggedUserPassword(body) {
    return api.request(`api/changeLoggedUserPassword`, "PATCH", body);
  }
  static async OfferSlider(body) {
    return api.request(`api/web/offerSliders/get`, "POST", body);
  }
  static async QueryQRCodeSession(body) {
    return api.request(`api/v2/queryQRCodeSession?_locale=${lang}`, "POST", body);
  }

  //PRODUCT
  static async Category(body) {
    return api.request(`api/web/category?_locale=${lang}`, "POST", body);
  }
  static async Type(body) {
    return api.request(`api/web/type?_locale=${lang}`, "POST", body);
  }
  static async GetProductsMappedwithSubCat(body) {
    return api.request(
      `api/web/product/getAllProductMappedSubCat?_locale=${lang}`,
      "POST",
      body
    );
  }
  static async SearchStoreProduct(body) {
    return api.request(`api/web/product/searchStoreProduct?_locale=${lang}`, "POST", body);
  }
  static async SearchStoreProductWithCategory(body) {
    return api.request(
      `api/v2/product/searchStoreProductWithCategory?_locale=${lang}`,
      "POST",
      body
    );
  }
  static async SearchStoreProductWithCategoryV2(body) {
    return api.request(
      `api/v2/product/searchSuggestionsV2?_locale=${lang}`,
      "POST",
      body
    );
  }
  static async SearchStoreProductBySubCategory(body) {
    if(body.search_query) {
      body.search_query = decodeURI(body.search_query);
    }
    return api.request(
      `web/v3/global/search?_locale=${lang}`,
      "POST",
      body
    );
  }
  static async GetAllProductMappedSubCatOutofStock(body) {
    return api.request(
      `api/web/product/getAllProductMappedSubCat?_locale=${lang}`,
      "POST",
      body
    );
  }
  static async GetProductsMappedwithCat(body) {
    return api.request(`api/product/getAllProductMappedCat?_locale=${lang}`, "POST", body);
  }
  static async GetAllProductMappedCatOutofStock(body) {
    return api.request(`api/product/getAllProductMappedCat?_locale=${lang}`, "POST", body);
  }
  static async GetProductBrands() {
    return api.request(`api/web/store/getBrand`, "POST");
  }
  static async GetBrandBySlug(slug) {
    return api.getRequest(`v1/api/getBrandDetail/${slug}`, "GET");
  }
  static async GetProductByRefId(body) {
    return api.request(`api/product/getProductByRef?_locale=${lang}`, "POST", body);
  }
  static async searchStoreProductByBrandRef(body) {
    return api.request(`api/product/searchStoreProductByBrandRef?_locale=${lang}`, "POST", body);
  }
  static async GetRelatedProduct(query) {
    return api.getRequest(`api/relatedProducts/get?product_id=${query.product_id}&limit=${query.limit}&page=${query.page}`, "GET");
  }
  static async getProductOfTheWeek() {
    return api.request("api/productOfTheWeek/get", "POST")
  }
  static async getShopByCats() {
    return api.request("api/shopByCats/get", "POST")
  }
  static async getSelectionBanners() {
    return api.request("api/selectionBanners/get", "POST")
  }
  static async getBottomBanner() {
    return api.getRequest('api/bottomBanner', "GET")
  }
  //USER
  static async AddAddress(body) {
    return api.request(`v1/web/address/create`, "POST", body);
  }
  static async GetAddress(body, expressMode) {
    return api.request(`api/address/getAllCustomerAddress?orderType=${expressMode ? 1 : 0}`, "POST", body);
  }
  static async UpdateAddress(body) {
    return api.request(`v1/web/address/update`, "POST", body);
  }
  static async DeleteAddress(body) {
    return api.request(`api/address/delete`, "POST", body);
  }
  static async GetPaymentMethod(){
    return api.getRequest(`api/payment/visaToken`, "GET");
  }
  static async DeletePaymentMethod(id){
    return api.deleteRequest(`api/payment/visaToken?id=${id}`, "DELETE");
  }
  static async EnableVisaToken(enable){
    return api.putRequest(`api/payment/visaToken?enable=${enable}`, "PUT");
  }

  static async getDelipointBalance() {
    return api.getRequest(`api/v1/delipoints/customer/current?_locale=${lang}`, "GET");
  }

  static async getDelipointTransactions(body = {}) {
    const next = body.next ?? 0;
    const limit = body.limit ?? 10;
    return api.getRequest(`api/v1/delipoints/customer/transactions/${next}/${limit}?_locale=${lang}`, "GET");
  }

  static async UpdateProfile(body) {
    return api.request(`api/users/updateCustomerUser`, "POST", body);
  }
  static async PastOrders(body) {
    return api.request(`api/cart/getUserPastOrder?_locale=${lang}`, "POST", body);
  }
  static async CurrentOrders(body) {
    return api.request(`api/cart/getUserCurrentOrder `, "POST", body);
  }
  static async FetchParticularOrder(body) {
	  return api.request(`api/v2/cart/fetchOrder?_locale=${lang}`, "POST", body);
  }
  static async AddItemToCart(body) {
	  return api.request(`v2/cart/addItemToCart?_locale=${lang}`, "POST", body);
  }
  static async RemoveItemFromCart(body) {
	  return api.request("v2/cart/removeItemFromCart", "POST", body);
  }
  static async UpdateItemQuantityCart(body) {
    return api.request(`v1/cart/updateItemQuantityCart?_locale=${lang}`, "POST", body);
  }
  static async ClearCart(body) {
    return api.request("api/cart/clearLatestCart", "POST", body);
  }
  static async FetchCart(body) {
	  return api.request(`v2/cart/fetchCart?_locale=${lang}`, "POST", body);
  }
  static async MoveToCheckout(body) {
    return api.request(`v1/cart/moveToCheckout?_locale=${lang}`, "POST", body);
  }
  static async ChangeOrderStatus(body) {
    return api.request(`v1/cart/changeOrderStatus?_locale=${lang}`, "POST", body);
  }
  static async AllDeliverySlots(body) {
    return api.request(`v1/web/slot/getSlotDates`, "POST", body);
  }

	static async getAllSlotsDelivery({orderType = 0, addressId = null}) {
		return api.getRequest(`v2/web/slot/getSlotDates?orderType=${orderType}&addressId=${addressId}`, "GET");
	}

  static async AllSlotsForDate(body) {
    return api.request(`api/getSlotDateTimings`, "POST", body);
  }
  static async PlaceOrder(body) {
    return api.request(`v1/cart/changeOrderStatus?_locale=${lang}`, "POST", body);
  }
  static async OpenPaymentDialog(body) {
    return api.request(`api/make/payment`, "POST", body);
  }
  static async PaymentCallback(body) {
    return api.request(`api/payment/callback`, "POST", body);
  }
  static async DeliveryCharges(body) {
    return api.request(`api/web/store/getOrderCharges`, "POST", body);
  }
  static async GetAllCouponCodes(body) {
    return api.request(`v1/coupons/order?_locale=${lang}`, "POST", body);
  }

  static async getAllCustomerPickCouponCode(body) {
    return await api.request(`v1/coupons/getAllCustomerPickCouponCode`, "POST", body);
  }
  static async getCouponCanApply(query) {
    return await api.getRequest(`v1/coupons/getCouponCanApply?order_id=${query.order_id}`, "GET");
  }

	static async ApplyCoupon(query) {
		return await api.getRequest(`v1/get/couponCode?code=${query.code}&order_id=${query.order_id}&type=${query.type}&address_id=${query.address_id || ''}&_locale=${lang}`, "GET");
	}
  static async OpenBasket(query) {
    return api.putRequest(`v2/web/basket/open?type=${query}`, "PUT");
  }
  static async CheckBasket(query) {
    return api.getRequest(`api/cart/checkBasket?type=${query}`, "GET");
  }
  static async Reorder(body) {
    return api.request(`v1/web/basket/reorder/?_locale=${lang}`, "POST", body);
  }
  static async CancelPayment(body) {
    return api.request(`api/payment/cancel`, "POST", body);
  }
  static async PaymentGateWay(body) {
	  let type = body.type || "web"
	  return api.request(`api/v3/webpay/gateWay?type=${type}&_locale=${lang}`, "POST", body)
  }

	static async getPaymentMethods() {
		return api.getRequest(`v1/shopsetting/paymentmethods`, "GET")
	}

  static async GetVisaToken() {
    return api.getRequest(`api/payment/visaToken`, "GET")
  }
  static async GetNewVisaToken() {
    return api.getRequest(`api/payment/visaToken/isNew`, "GET")
  }
  // static async getOrderPaymentStatus(body){
  //   return api.request("/api/payment/getOrderPaymentStatus", "POST", body)
  // }

  // Favorites
  static async AddItemToFavorites(body) {
    return api.request(`api/favorites/add`, "POST", body);
  }
  static async RemoveItemFromFavorites(query) {
    return api.putRequest(`api/favorites/remove?item_id=${query.item_id}&type=${query.type}`, "PUT");
  }
  static async RemoveAllItemFromFavorites(query) {
    return api.putRequest(`api/favorites/removeAll?&type=${query.type}`, "PUT");
  }
  static async FetchFavoritesItems(query) {
    let offset = query?.page && query?.limit ? `&page=${query?.page}&limit=${query?.limit}` : ``;
    return api.getRequest(`api/favorites/get?_locale=${lang}&type=${query.type}${offset}${(query?.notificationId !== null && query?.notificationId?.trim() !== '' ) ? `&notificationId=${query.notificationId}`:``}`, "GET");
  }

  //Notification
  static async GetNotifications(query) {
    return api.getRequest(`api/notification/getAll/?page=${query.page}&limit=${query.limit}&_locale=${lang}`, "GET");
  }
  static async GetNotification (query) {
    return api.getRequest(`api/notification/get?notification_id=${query.notification_id}`, "GET");
  }
  static async GetCountUnreadNotifications() {
    return api.getRequest(`api/notification/getCountUnreadNotifications`, "GET");
  }
  static async MarkNotification(query) {
    return api.putRequest(`api/notification/markAsRead?notification_id=${query.notification_id}`, "PUT");
  }
  static async markAllNotifications() {
    return api.putRequest(`api/notification/markAllAsRead`, "PUT");
  }

  // Sale Promotion Campaigns
  static async GetActiveSaleCampaign(){
    return api.getRequest(`api/v1/campaign/get/active`, "GET");
  }
  static async GetAllProductsSaleCampaign(body){
    return api.request(`api/v1/campaign/products/get?_locale=${lang}`, "POST", body);
  }
  static async getHomePageReviewCard(body) {
    return api.request('api/getHomePageReviewCard', "POST",body);
  }

  // store logo
  static async getStoreLogo() {
    return api.getRequest('api/v1/app-config/web', "GET");
  }

  //
  static async getCustomerMailSubscribe(mail) {
    return api.getRequest(`api/v1/mail/subscriber/${mail}`, "GET");
  }

  static async customerUpdateMailSubscribe(mail,body) {
    return api.putRequest(`api/v1/mail/subscriber/${mail}`, "PUT",body);
  }
  
  static async getFeatureMaintenance() {
    return api.getRequest('api/get/maintenance', "GET");
  }

  static async getPageSelection(body) {
    return api.getRequest(`api/v1/web/selection-page/${body.page_type}/${body.page}/${body.limit}`, "GET");
  }

  static async getProductsSelection(page_type,page,limit,qry) {
    return api.request(`api/v1/web/products-selection/${page_type}/${page}/${limit}`, "POST",qry);
  }
  static async getPageSelectionBySlug(slug) {
    return api.getRequest(`api/v1/web/products-selection/${slug}`, "GET");
  }
  static async getPageSelectionInfoBySlug(slug) {
    return api.getRequest(`api/v1/web/selection-page-info/${slug}`, "GET");
  }

  static async getIp() {
    return api.getRequest(`api/ip`, "GET");
  }

  //map suggestion
  static async addressSuggestion(search) {
    return api.getRequest(`v1/address/placesSuggestion?input=${search}`, "GET");
  }

  static async addressGeoCod({lat, lng, placeId}) {
    let endpoint = ``;
    if(placeId){
      endpoint = `v1/address/geocode?placeId=${placeId}`
    }else{
      endpoint = `v1/address/geocode?lat=${lat}&lng=${lng}`
    }
    return api.getRequest(endpoint, "GET");
  }

  static async addressViewPort({northeast, southwest}) {
    return api.getRequest(`v1/address/viewport?northeast=${northeast}&lng=${southwest}`, "GET");
  }

  static async findTrackingCode(trackingCode, {orderId, courierCompany, getType}) {
	  return api.getRequest(`api/v1/cp/tracking-event?trackingCode=${trackingCode}&orderId=${orderId}&courierCompany=${courierCompany}&type=${getType}`, "GET");
  }

	static async getProducts(params = {}) {
		params._locale = lang
		if (user) {
			params.userId = JSON.parse(user)?.cust_id
		}
		// Clean params - remove null/undefined/empty values
		const cleanParams = {};
		Object.entries(params).forEach(([key, value]) => {
			if (value !== null && value !== undefined && value !== '') {
				cleanParams[key] = value;
			}
		});

		// Build query string
		const queryString = new URLSearchParams(cleanParams).toString();

		// Build endpoint URL
		const endpoint = queryString
			? `api/products?${queryString}`
			: 'api/products';
		return api.getRequest(endpoint, "GET");
	}

	static async getProductsFiltersOption(params = {}) {
		params._locale = lang
		if (user) {
			params.userId = JSON.parse(user)?.cust_id
		}
		// Clean params - remove null/undefined/empty values
		const cleanParams = {};
		Object.entries(params).forEach(([key, value]) => {
			if (value !== null && value !== undefined && value !== '') {
				cleanParams[key] = value;
			}
		});

		// Build query string
		const queryString = new URLSearchParams(cleanParams).toString();

		// Build endpoint URL
		const endpoint = queryString
			? `api/products/filters-option?${queryString}`
			: 'api/products';
		return api.getRequest(endpoint, "GET");
	}

}
